
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 15,
  height: 18,
  textRendering: "geometricPrecision",
  viewBox: "0 0 15 18"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAMAAACzQHQ9AAAAflBMVEVMaXF0cnR0c3Vzc3RzcnV1cnV5cnlzcnR0cnRzcnVzcnVzcnX///97cntxcXF0c3VzcnR0cnVtbW10dHR2dnZ0c3Z1dXV0c3V0c3R0dHRzc3h0cnVzc3Vzc3V0dHR2cnZ2dnZzc3Z4eHh1cnV1dXV1c3V0dHZ2dnZycnZ3cnfDu0KDAAAAKnRSTlMAmtiK1GAm5pHd38kBHRvg4qMHLhynU+W0CzOumZBYQxpfEWIlg4I4ODoace2XAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAgElEQVR42lWN1w7DIBAELxBnMe6999T//8E4xBYwD7sa7UlHpEjvKWnCJEachKfmLOIbj1h+eCGzPTNZ/LWpnqofVaO6Ram6RLvnq+9QX37U6Po3DbhqMJBwjceuODxwAtN9D55v7gzMuh8xWj5hsnz9rKfLm0YK4jDhNC+OZpm/XDAH1DY8VsMAAAAASUVORK5CYII=",
  width: 15,
  height: 18,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAMAAACzQHQ9AAAAflBMVEVMaXF0cnR0c3Vzc3RzcnV1cnV5cnlzcnR0cnRzcnVzcnVzcnX///97cntxcXF0c3VzcnR0cnVtbW10dHR2dnZ0c3Z1dXV0c3V0c3R0dHRzc3h0cnVzc3Vzc3V0dHR2cnZ2dnZzc3Z4eHh1cnV1dXV1c3V0dHZ2dnZycnZ3cnfDu0KDAAAAKnRSTlMAmtiK1GAm5pHd38kBHRvg4qMHLhynU+W0CzOumZBYQxpfEWIlg4I4ODoace2XAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAgElEQVR42lWN1w7DIBAELxBnMe6999T//8E4xBYwD7sa7UlHpEjvKWnCJEachKfmLOIbj1h+eCGzPTNZ/LWpnqofVaO6Ram6RLvnq+9QX37U6Po3DbhqMJBwjceuODxwAtN9D55v7gzMuh8xWj5hsnz9rKfLm0YK4jDhNC+OZpm/XDAH1DY8VsMAAAAASUVORK5CYII=",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"15\" height=\"18\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 15 18\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAMAAACzQHQ9AAAAflBMVEVMaXF0cnR0c3Vzc3RzcnV1cnV5cnlzcnR0cnRzcnVzcnVzcnX///97cntxcXF0c3VzcnR0cnVtbW10dHR2dnZ0c3Z1dXV0c3V0c3R0dHRzc3h0cnVzc3Vzc3V0dHR2cnZ2dnZzc3Z4eHh1cnV1dXV1c3V0dHZ2dnZycnZ3cnfDu0KDAAAAKnRSTlMAmtiK1GAm5pHd38kBHRvg4qMHLhynU+W0CzOumZBYQxpfEWIlg4I4ODoace2XAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAgElEQVR42lWN1w7DIBAELxBnMe6999T//8E4xBYwD7sa7UlHpEjvKWnCJEachKfmLOIbj1h+eCGzPTNZ/LWpnqofVaO6Ram6RLvnq+9QX37U6Po3DbhqMJBwjceuODxwAtN9D55v7gzMuh8xWj5hsnz9rKfLm0YK4jDhNC+OZpm/XDAH1DY8VsMAAAAASUVORK5CYII=\" width=\"15\" height=\"18\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAMAAACzQHQ9AAAAflBMVEVMaXF0cnR0c3Vzc3RzcnV1cnV5cnlzcnR0cnRzcnVzcnVzcnX///97cntxcXF0c3VzcnR0cnVtbW10dHR2dnZ0c3Z1dXV0c3V0c3R0dHRzc3h0cnVzc3Vzc3V0dHR2cnZ2dnZzc3Z4eHh1cnV1dXV1c3V0dHZ2dnZycnZ3cnfDu0KDAAAAKnRSTlMAmtiK1GAm5pHd38kBHRvg4qMHLhynU+W0CzOumZBYQxpfEWIlg4I4ODoace2XAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAgElEQVR42lWN1w7DIBAELxBnMe6999T//8E4xBYwD7sa7UlHpEjvKWnCJEachKfmLOIbj1h+eCGzPTNZ/LWpnqofVaO6Ram6RLvnq+9QX37U6Po3DbhqMJBwjceuODxwAtN9D55v7gzMuh8xWj5hsnz9rKfLm0YK4jDhNC+OZpm/XDAH1DY8VsMAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/lock.461a33e31b043e0462f1aa4422eeaa2d.svg"),
        {
          React: SvgLock,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      